<template>
	<div>
		<div class="captail_wrap registrationSteps position-relative fullLoader p-0">
            <div class="authincation h-100 w-100">
		        <div class="container h-100">
		            <div class="row justify-content-center h-100 align-items-center">
		                <div class="col-md-5">
		                    <div class="form-input-content text-center error-page">
		                        <h1 class="error-text font-weight-bold">404</h1>
		                        <h4><span class="emoji">&#128532;</span> The page you were looking for is not found!</h4>
		                        <p>You may have mistyped the address or the page may have moved.</p>
								<div>
		                            <router-link class="cap_btn blue" to="/home">Back to Home</router-link>
		                        </div>
		                    </div>
		                </div>
		            </div>
		        </div>
		    </div>
		</div>
	</div>
</template>

<script>
	export default {
		name: '404-not-found',
		data() {
			return { }
		},
		methods: { }
	}
</script>



// WEBPACK FOOTER //
// src/components/website/shared/notFound404.vue